import { useLocation } from "react-router-dom";

const ThankYou = () => {
  const query = new URLSearchParams(useLocation().search);

  return (
    <div
      style={{
        margin: "0 auto",
        maxWidth: 1300,
        height: "80vh",
        display: "flex",
        justifyContent: "center",
        flexDirection: "column",
      }}
    >
      <p
        style={{
          lineHeight: 2,
          fontWeight: 600,
          textTransform: "capitalize",
          fontSize: "2em",
          marginBottom: 0,
        }}
      >
        Thank you {query.get("name")}!
      </p>
      <p style={{ fontSize: "1.2em" }}>Your form submitted successfully</p>
    </div>
  );
};

export default ThankYou;
